"use client";

import React, { useMemo } from "react";
import {
  ConnectionProvider,
  WalletProvider,
} from "@solana/wallet-adapter-react";
import { WalletAdapterNetwork } from "@solana/wallet-adapter-base";
import { clusterApiUrl } from "@solana/web3.js";
import "@solana/wallet-adapter-react-ui/styles.css";
import { getEnv } from "@bkry/bowline-utils";

import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { getProjectAttributes } from "@bkry/bowline-redux/projects";

export function SolanaProvider({ children }) {
  const REACT_APP_PROJECT_ID = getEnv("REACT_APP_PROJECT_ID");
  const REACT_APP_SOLANA_RPC_URL = getEnv("REACT_APP_SOLANA_RPC_URL");
  const projectData = useSelector((state) =>
    getProjectAttributes(state, REACT_APP_PROJECT_ID)
  );
  let endpoint = useMemo(
    () => clusterApiUrl(WalletAdapterNetwork.Devnet),
    [WalletAdapterNetwork.Devnet]
  );

  if (projectData?.default_network === "solana") {
    if (REACT_APP_SOLANA_RPC_URL) {
      console.log("Using custom Solana RPC URL:", REACT_APP_SOLANA_RPC_URL);
      endpoint = REACT_APP_SOLANA_RPC_URL;
    } else {
      endpoint = useMemo(
        () => clusterApiUrl(WalletAdapterNetwork.Devnet),
        [WalletAdapterNetwork.Mainnet]
      );
    }
  }

  return (
    <ConnectionProvider endpoint={endpoint}>
      <WalletProvider wallets={[]}>{children}</WalletProvider>
    </ConnectionProvider>
  );
}

SolanaProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
